import {GemModule, GemModuleItem} from 'app/interface';

import {GemSettings} from '../config/interface';

export const initModule = async (gemModuleItem: GemModuleItem, element: HTMLElement, config: any, gemSettings: GemSettings) => {
    const moduleName = element.dataset.gemModuleName;

    try {
        const module = (await gemModuleItem.import?.({element, config, gemSettings})) as GemModule;
        if (module?.init) {
            return module.init({element, config, gemSettings});
        }
    } catch (error) {
        console.error(`Error while initialization - component: "${moduleName}".`, {element, config});
        console.error(error);
    }
};
